import {BASE_PATH, BASE_PATH_EXTENSION_ADMIN} from "../../utils/constants";
import {getToken} from "../Auth/token";
import axios from "axios";

const baseUrl = `${BASE_PATH}${BASE_PATH_EXTENSION_ADMIN}`;

export function apiLogVerifactu() {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`} };
    return axios.get(`${baseUrl}/log/verifactu`, config);
}
